"use strict";

exports.__esModule = true;
exports.AdvancedTimelineBrushSelector = AdvancedTimelineBrushSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
var _LayoutSettingsContext = require("../../ConfigurableLayout/LayoutSettingsContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AdvancedTimelineBrushSelector(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var layoutSettings = _react["default"].useContext(_LayoutSettingsContext.LayoutSettingsContext);
  var elementEditor = props.elementEditor,
    element = props.element,
    path = props.path;
  if (!layoutSettings.stripeChart.allowSelection) {
    return null;
  }
  var canBrush = element.props.dataRange !== "SELECTION";
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    helperText: canBrush ? translate("StripeChartFields.showBrush.label", "Enable brushing a selection on the chart.") : translate("StripeChartFields.showBrush.label.disabled", "Brushing is only available when using Reporting Period for the Date Range.")
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    id: "showBrush",
    label: translate("AdvancedTimeline.BrushSelector.showBrush.allowSelection.label", "Allow selection"),
    disabled: !canBrush,
    checked: canBrush ? element.props.showBrush || false : false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "showBrush", e.target.checked);
    }
  })), element.props.showBrush && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    id: "enableDragging",
    label: translate("AdvancedTimeline.BrushSelector.brushEnableDragging.allowDragging.label", "Allow dragging"),
    checked: element.props.brushEnableDragging === undefined ? true : element.props.brushEnableDragging,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "brushEnableDragging", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    id: "brushEnableResize",
    label: translate("AdvancedTimeline.BrushSelector.brushEnableResize.allowResizing.label", "Allow resizing"),
    checked: element.props.brushEnableResize === undefined ? true : element.props.brushEnableResize,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "brushEnableResize", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    id: "brushEnableSnapToSelection",
    label: translate("AdvancedTimeline.BrushSelector.brushEnableSnapToSelection.clickToSelect.label", "Click to select"),
    checked: element.props.brushEnableSnapToSelection === undefined ? true : element.props.brushEnableSnapToSelection,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "brushEnableSnapToSelection", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    id: "brushEnableSnapToTimeline",
    label: translate("AdvancedTimeline.BrushSelector.brushEnableSnapToTimeline.snapToEdge.label", "Snap to edge"),
    checked: element.props.brushEnableSnapToTimeline === undefined ? true : element.props.brushEnableSnapToTimeline,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "brushEnableSnapToTimeline", e.target.checked);
    }
  })));
}